import React, { FunctionComponent } from 'react';
import { SEOHeaderTags } from 'components/SEO/SEOHeaderTags';
import { RecordingModel } from 'features/recordings/RecordingModel';
import { useSEOTitleDescription } from 'hooks/useSEOTitleDescription';
import { SmartBanner } from 'components/SmartBanner';

interface RecordingHeaderTagsProps {
  recording: RecordingModel | null;
}

export const RecordingHeaderTags: FunctionComponent<
  RecordingHeaderTagsProps
> = ({ recording }) => {
  const { pageTitle, pageDescription } = useSEOTitleDescription(
    recording?.title,
    recording?.description
  );

  if (!recording) {
    return null;
  }

  return (
    <>
      <SEOHeaderTags
        title={pageTitle}
        description={pageDescription}
        image={recording.artworkUrl()}
        url={window.location.href}
      />
      <SmartBanner type={'recording'} />
    </>
  );
};
